module.exports = __webpack_public_path__ + "img/10.e9167257.png";